import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import TransporteurSelect from 'components/Shared/TransporteurSelect';

import { ReclamationActionDetailCodes } from 'constants.js';
import { ReclamationActionDetailType } from 'constants.js';



class DetailsComplementairesRapidoTransportContent extends React.Component {

    constructor(props) {
        super(props);
                        
        let commentaire = ``;


        this.state = {
            numerosRecepisses: '',
            transporteurId: props.transporteurId,
            dateExpeditionPhysique: '',
            dateEnvoiEDITransport: '',
            commentaire: commentaire
        };
    }

    componentDidMount() {
        const details = this.getDetails(this.state);

        this.props.onChange(details);
    }

    getDetails(newState) {

        const details = {
            valide: false,
            items: []
        };


        if (newState.transporteurId === -1) {
            return details;
        }

        if (newState.numerosRecepisses === '') {
            return details;
        }

        if (newState.dateExpeditionPhysique === '') {
            return details;
        }

        if (newState.dateEnvoiEDITransport === '') {
            return details;
        }
        

        var detail = {
            code: ReclamationActionDetailCodes.NumerosRecepisses,
            type: ReclamationActionDetailType.Texte,
            libelle: 'Numéro du ou des récépissés concerné par la pièce',
            position: details.items.length,
            valeurString: newState.numerosRecepisses
        };
        details.items.push(detail);

        detail = {
            code: ReclamationActionDetailCodes.Transporteur,
            type: ReclamationActionDetailType.TransporteurId,
            libelle: 'Transporteur',
            position: details.items.length,
            valeurInteger: newState.transporteurId
        };
        details.items.push(detail);


        detail = {
            code: ReclamationActionDetailCodes.DateExpeditionPhysique,
            type: ReclamationActionDetailType.Date,
            libelle: `Date d'expédition physique`,
            position: details.items.length,
            valeurDate: newState.dateExpeditionPhysique
        };
        details.items.push(detail);


        detail = {
            code: ReclamationActionDetailCodes.DateEnvoiEDITransport,
            type: ReclamationActionDetailType.Date,
            libelle: `Date envoi EDI transport`,
            position: details.items.length,
            valeurDate: newState.dateEnvoiEDITransport
        };
        details.items.push(detail);


        detail = {
            code: ReclamationActionDetailCodes.Commentaire,
            type: ReclamationActionDetailType.Texte,
            libelle: 'Commentaire',
            position: details.items.length,
            valeurString: newState.commentaire
        };
        details.items.push(detail);


        details.valide = true;
        return details;

    }

    handleChange = (event) => {
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        const details = this.getDetails(newState);

        this.props.onChange(details);
    }

    render() {
        const { transporteurId } = this.state;
        
        return (
            <Stack spacing={1}>
                <Typography variant="body1" gutterBottom>Veuillez spécifier : </Typography>

                <TextField id="numerosRecepisses" name="numerosRecepisses" label="Numéro du ou des récépissés concerné par la pièce" type="text" value={this.state.numerosRecepisses} onChange={this.handleChange} fullWidth multiline required />

                <TransporteurSelect value={transporteurId} onChange={this.handleChange} all={false} isRequired />

                <TextField id="dateExpeditionPhysique" name="dateExpeditionPhysique" label="Date d'expédition physique" type="date" value={this.state.dateExpeditionPhysique} onChange={this.handleChange} InputLabelProps={{ shrink: true }} fullWidth required/>

                <TextField id="dateEnvoiEDITransport" name="dateEnvoiEDITransport" label="Date envoi EDI transport" type="date" value={this.state.dateEnvoiEDITransport} onChange={this.handleChange} InputLabelProps={{ shrink: true }} fullWidth required/>
                
                <TextField id="commentaire" name="commentaire" label="Commentaire" type="text" value={this.state.commentaire} onChange={this.handleChange} fullWidth multiline />
            </Stack>
        );
    }
}

DetailsComplementairesRapidoTransportContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    transporteurId: PropTypes.number.isRequired
};

export default DetailsComplementairesRapidoTransportContent;